/**
 * HTTP layer for product bills of materials. The component lines that make up a
 * manufactured product.
 *
 * Contains:
 * - fetchProductBoms / fetchProductBom: reads
 * - postProductBom / patchProductBom / deleteProductBom: writes
 */
import apiClient from '@sophocles/http-common';

const PRODUCT_BOM_ENDPOINT = '/warehouse/product-boms';

export const fetchProductBoms = queryParams =>
  apiClient.get(`${PRODUCT_BOM_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchProductBom = productBOMId =>
  apiClient.get(`${PRODUCT_BOM_ENDPOINT}/${productBOMId}/`).then(res => res.data);

export const postProductBom = data => apiClient.post(`${PRODUCT_BOM_ENDPOINT}/`, data).then(res => res.data);

export const patchProductBom = (productBOMId, data) =>
  apiClient.patch(`${PRODUCT_BOM_ENDPOINT}/${productBOMId}/`, data).then(res => res.data);

export const deleteProductBom = productBOMId => apiClient.delete(`${PRODUCT_BOM_ENDPOINT}/${productBOMId}/`);
